import { Button } from '~/shared/components/buttons/Button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useFormRegistry } from '~/shared/forms/FormRegistryContext';
import { useGoalsAndInterventionsWizard } from '../GoalsAndInterventionsWizardContext';
import { useSuspenseQuery } from '@tanstack/react-query';
import { getFullGoalDefinitionOptions } from '@generated';
import { convertClientDateToServerDate } from '~/util/date';

export function CapturePredefinedGoalDetailsFooter() {
	const { wizardState, dispatch, certificationPeriod } = useGoalsAndInterventionsWizard();
	const { isValidByForm, getFormValues } = useFormRegistry();

	if (!wizardState.selectedGoal || wizardState.selectedGoal.type !== 'predefined') {
		throw new Error(
			'PredefinedGoalDetailsNextButton can only be used when the selectedGoal is of type "predefined" and has a fullGoalDefinition'
		);
	}
	const newGoalId = wizardState.selectedGoal.newGoalId;

	const { data: fullGoalDefinition } = useSuspenseQuery(
		getFullGoalDefinitionOptions(wizardState.selectedGoal.goalDefinition.id, convertClientDateToServerDate(certificationPeriod.startDate))
	);

	const nextClicked = () => {
		const formValues = getFormValues(newGoalId);
		dispatch({ type: 'PREDEFINED-GOAL-DETAILS-ENTERED', formValues: formValues, fullGoalDefinition: fullGoalDefinition });
	};

	return (
		<div className="flex items-center gap-2">
			<Button onClick={() => dispatch({ type: 'PREVIOUS_CLICKED' })} Icon={ChevronLeft} label="Previous" />
			<Button onClick={nextClicked} Icon={ChevronRight} label="Next" isDisabled={!isValidByForm[newGoalId]} />
		</div>
	);
}
